import React from "react";
import {SvarReadTypeProps} from "./svarReadTypeCompareMap";

export const TekstReadSvar = ({ evalueringSvar }: SvarReadTypeProps) => {
    return (<div>{evalueringSvar.tekstSvar}</div>)
};
